import { useEffect, useState } from 'react';
import { Button, Stack, Text } from '@mantine/core';
import { checkSupport, getSubscription, subscribePush } from '../../../push/client.js';
import { BellIcon } from '../../../components/client/clientIcons.js';

/** CTA на hero: показывается только если push поддерживается и ещё не включён. */
export function HeroPushButton() {
  const sup = checkSupport();
  const [subscribed, setSubscribed] = useState<boolean | null>(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  // null — ошибок не было; 'denied' — браузер заблокировал (повторный клик бессмыслен);
  // 'failed' — прочая ошибка, повтор имеет смысл.
  const [error, setError] = useState<'denied' | 'failed' | null>(null);

  useEffect(() => {
    if (!sup.ok) return;
    getSubscription().then((s) => setSubscribed(!!s)).catch(() => setSubscribed(null));
  }, [sup.ok]);

  if (!sup.ok || subscribed !== false) return null;

  const turnOn = async () => {
    setBusy(true);
    setError(null);
    const r = await subscribePush();
    setBusy(false);
    if (r.ok) { setSubscribed(true); setDone(true); return; }
    setError(r.reason === 'permission_denied' ? 'denied' : 'failed');
  };

  const hintStyle = { fz: 13, c: 'rgb(255 255 255 / 75%)' } as const;

  // Разрешение отклонено навсегда — кнопка бесполезна, показываем только пояснение.
  if (error === 'denied') {
    return <Text {...hintStyle}>Уведомления заблокированы в настройках браузера</Text>;
  }

  const button = (
    <Button
      onClick={turnOn}
      loading={busy}
      leftSection={<BellIcon size={16} />}
      radius="md"
      h={44}
      styles={{
        root: {
          background: 'rgb(255 255 255 / 12%)',
          border: '1px solid rgb(255 255 255 / 25%)',
          backdropFilter: 'blur(4px)',
          color: '#fff',
          fontWeight: 500,
        },
      }}
    >
      {done ? 'Уведомления включены' : 'Включить push-уведомления'}
    </Button>
  );

  if (error === 'failed') {
    return (
      <Stack gap={6} align="flex-start">
        {button}
        <Text {...hintStyle}>Не удалось включить уведомления. Попробуйте ещё раз.</Text>
      </Stack>
    );
  }

  return button;
}
